<div class="mini-card">
    <div class="icon-description">
        <div class="icon-container">
            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 104.12 122.88"><title>folder-category</title><path d="M8,0V33.06H36.47v8H8v63.61H36v8H0V0ZM45.31,92.07l3.83,28.87a2,2,0,0,0,1.8,1.94H97.37c1.07,0,1.67-1,1.8-2l5-28.81Zm2.37-8.24-2.13,4.73h58.39l-2.15-4.74h-26a1.55,1.55,0,0,1-1.56-1.56V78.55H52v3.73a1.54,1.54,0,0,1-1.55,1.55ZM45.31,28.4l3.83,28.86a2,2,0,0,0,1.8,1.94H97.37c1.07,0,1.67-1,1.8-2l5-28.82Zm2.37-8.24-2.13,4.72h58.39l-2.15-4.73h-26a1.56,1.56,0,0,1-1.56-1.56V14.88H52V18.6a1.55,1.55,0,0,1-1.55,1.56Z" fill="#fff"/></svg>
        </div>
        <div class="link-label">Categories</div>
    </div>
    <div class="tasks">
        Tasks go here
    </div>
</div>
